import BaseModel from '@/shared/models/BaseModel'
import _         from 'lodash'

export default class CompanyJson extends BaseModel {

    defaults() {
        return {
            id                   : '',
            official_program_name: '',
            program_name         : '',
            logo_url             : '',
            blocked_at           : '',
            favicon_url          : '',
            landing_page_domain  : '',
            background_color     : '#0F0F0F',
            font_color           : '#F9F9F9',
            primary_color        : '#3F51B5',
            background_url       : '',
            frontend_domain      : '',
            admin_domain         : '',
            display_mode         : '',
            hide_cashback        : '',
            hide_points          : '',

            frontend: {
                register: {
                    opt_in_marketing: {
                        label: '',
                    },
                },
            },
            home                 : {
                title: '',
                hero    : {
                    title: '',
                    subtitle: '',
                    description: '',
                    custom_class: '',
                    customClass : '',
                    background_url: '',
                    customHeight: '',
                    height: 'medium', // 'small', 'medium', 'large', 'fullheight'
                },
                features: {
                    title: '',
                    subtitle: '',
                    description: '',
                    items: [
                        { title: 'Fácil', icon: 'check-circle', customColor: '#43A047', action: 'Conheça', to: { name: 'how-it-works' }, description: 'Veja como é fácil e aproveite todos os benefícios...' },
                        // { title: 'Seguro',        icon: 'lock',         customColor: '#2E7D32', action: null,          to: null,                     description: 'sit dolor amet.' },
                        { title: 'Já tem conta?', icon: 'user-circle', customColor: '#F4511E', action: 'Minha conta', href: 'FRONTEND', description: 'Acesse e consulte o seu saldo.' },
                    ],
                },
            },
            banner: {
                title: 'Pronto para conhecer',
            },
            how_it_works: {
                title: 'Como funciona?',
                hero: {
                    title: '',
                    subtitle: '',
                    description: '',
                    custom_class: '',
                    customClass: '',
                    background_url: '',
                    customHeight: '',
                    height: 'medium',  // 'small', 'medium', 'large', 'fullheight'
                },
                features: {
                    title: '',
                    subtitle: '',
                    description: '',
                    
                    //[TO-DO] Add texto dinâmicamente do backend
                    items: [
                        { title: 'Cadastre-se', icon: 'user-circle', customColor: '#F4511E', action: 'Cadastre-se agora', href: 'FRONTEND', description: 'O cadastro é rápido e seguro!' },
                        { title: 'Acumule', icon: 'dot-circle', customColor: '#039BE5', action: null, to: null, description: 'Consuma em qualquer uma de nossas unidades e informe seu CPF.' },
                        { title: 'Troque', icon: 'hand-holding-usd', customColor: '#2E7D32', action: null, to: null, description: 'Ao acumular Saldo, o cliente poderá trocar por Prêmios disponíveis no site (de acordo com seu saldo).' },
                        // { title: 'Prêmios',      icon: 'trophy', customColor: '#f4bc1e', action: null,          to: null,                       description: 'Ao atingir o próximo nível, resgate prêmios exclusivos e obtenha novos benefícios.' },
                    ],
                }
            },
            landing_page_colors:{
                nav_font_color       : '#F9F9F9',
                nav_background_color : '#3F51B5',
                title_color          : '#3F51B5',
                card_font_color      : '#F9F9F9',
                card_background_color: '#3F51B5',
            },
            description: {
                title: 'Se inscreva já e ganhe pontos',
                description: 'Ao consumir nossos produtos você recebe parte do valor consumido em pontos para troca-lós em novos produtos. '
            },
            faq: {
                title: 'Perguntas Frequentes',
                items: [],
            },
            legal: {
                cookie_policy_url : '',
                privacy_policy_url: '',
                terms_url         : '',
            },
            footer: {
                left_text  : '',
                right_text : '',
                right_title: '',
                text : '',
                links: [],
                mark: {
                    text: '',
                    url : ''
                },
            },
        }
    }

    // Retorna o json completo com todas as chaves com valores default
    completeJson(data, defaults = this.defaults()) {
        let complete = {}

        if (!data)
            return defaults

        for (let key in defaults) {
            complete[key] = _.isNil(data[key]) ? defaults[key] : data[key]

            if (typeof complete[key] == 'object' && !Array.isArray(complete[key]) && !_.isEmpty(complete[key]))
                complete[key] = this.completeJson(complete[key], defaults[key])
        } 

        return complete
    }

    static displayModes() {
        return [
            { value: 'POINTS', text: 'Pontos' }, // [TODO] Traduzir e utilizar constantes
            { value: 'PERCENTAGE', text: 'Porcentagem' },
            { value: 'CASH', text: 'Dinheiro' }
        ]
    }

    static mapDisplay(display) {
        const filtered = (this.displayModes()).find(v => v.value == display)

        return filtered ? filtered.value : 'POINTS'
    }

    // Não precisa de validação, pois não havera o cadastro nesta app
    
}